import React from 'react';
import { isToggleEnabled } from 'react-awesome-feature-toggles/dist/feature-toggles';
import { useIntl } from 'react-intl';
import { notification } from 'ui';
import WarningNotification from '../../common/publish-steps/WarningNotification';

/**
 * Checks if a notification should be shown to user based on feature flag
 *
 * @param {*} flag The feature flag to check
 * @param {*} titleKey The key of the title translation
 * @param {*} messageKey The key of the message translation
 * @returns a function with the flagged action as parameter to trigger the check
 */
const useFeatureFlag = (flag, titleKey, messageKey) => {
  const intl = useIntl();
  const trigger = (action) => {
    if (!flag || !isToggleEnabled(flag)) {
      action();
    } else if (isToggleEnabled(flag)) {
      notification.info({
        message: intl.formatMessage({ id: `featureFlagErrors.${titleKey}` }),
        placement: 'top',
        description: <WarningNotification
          onConfirm={() => {
            action();
            notification.destroy('featureFlagNotification');
          }}
          body={intl.formatMessage({ id: `featureFlagErrors.${messageKey}` }, { br: <br /> })}
          onClose={() => { notification.destroy('featureFlagNotification'); }}
          closeButtonText={intl.formatMessage({ id: 'common.CANCEL' })}
          confirmButtonText={intl.formatMessage({ id: 'common.PROCEED' })}
        />,
        className: 'extended-notification',
        key: 'featureFlagNotification',
        duration: 0,
      });
    }
  };
  return [trigger];
};

export default useFeatureFlag;
